import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

function removeParameterFromUrl(url, parameter) {
  return url
    .replace(new RegExp("[?&]" + parameter + "=[^&#]*(#.*)?$"), "$1")
    .replace(new RegExp("([?&])" + parameter + "=[^&]*&"), "$1");
}

export default class extends Controller {
  connect() {}

  translate(e) {
    // On loading, if there is an anchor query parameter, move it to the real anchor and load it
    // For context see https://github.com/hotwired/turbo/issues/211, the current browser model
    // removes anchors in javascript fetch events which Turbo uses internally.

    if (e.detail.url.includes("?") && e.detail.url.includes("anchor")) {
      const params = new URLSearchParams(
        e.detail.url.substring(e.detail.url.indexOf("?") + 1),
      );
      const anchor = params.get("anchor");
      if (anchor) {
        // Don't continue this loading, instead, issue a new loading request
        e.preventDefault();

        const target =
          removeParameterFromUrl(e.detail.url, "anchor") + "#" + anchor;
        Turbo.visit(target, {
          action: "replace",
        });
      }
    }
  }
}
